/**
 * Validates whether a string looks like an email address.
 * @param email - Raw user input from form controls.
 * @returns True when the value matches the accepted email pattern.
 */
export function ValidateEmail(email: string) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (email.match(validRegex)) {
    return true;
  } else {
    return false;
  }
}

/**
 * Creates an isolated shadow root for popup or overlay rendering.
 * @param root - Host element where the shadow host will be appended.
 * @returns The created open shadow root instance.
 */
export function createShadow(root: any) {
  const div = document.createElement('div');
  const style = document.createElement('style');
  style.innerHTML = ':host { all: initial; }';
  const shadow = div.attachShadow({ mode: 'open' });
  shadow.appendChild(style);
  root.appendChild(div);
  return shadow;
}